import React from 'react';
import {
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';

const DeleteFileModal = ({
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleConfirmDelete,
}) => {
    return (
        <Dialog
            open={isDeleteModalOpen}
            onClose={() => setIsDeleteModalOpen(false)}
            maxWidth="xs"
        >
            <DialogTitle sx={{ fontWeight: 700, pt: 3 }}>파일 삭제 확인</DialogTitle>
            <DialogContent>
                <Typography>
                    등록된 파일을 삭제하시겠습니까?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={() => setIsDeleteModalOpen(false)} color="inherit">
                    취소
                </Button>
                <Button 
                    // onClick={clearUploadedData}
                    onClick={handleConfirmDelete}
                    variant="contained" 
                    color="error"
                >
                    삭제
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteFileModal;